var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_838_15683",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.350586,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_838_15683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5616 16.2583L16.9577 9.86214L16.25 9.15444L10.5616 14.8429L7.71155 11.9929L7.00385 12.7006L10.5616 16.2583ZM12.0034 21.3506C10.7588 21.3506 9.58872 21.1144 8.4931 20.6421C7.39748 20.1698 6.44444 19.5288 5.63397 18.7191C4.82352 17.9094 4.18192 16.9572 3.70915 15.8626C3.23638 14.768 3 13.5985 3 12.3539C3 11.1094 3.23616 9.9393 3.70848 8.84369C4.18081 7.74807 4.82183 6.79503 5.63153 5.98456C6.44123 5.17411 7.39337 4.5325 8.48795 4.05974C9.58255 3.58697 10.7521 3.35059 11.9966 3.35059C13.2412 3.35059 14.4113 3.58674 15.5069 4.05906C16.6025 4.53139 17.5556 5.17241 18.366 5.98211C19.1765 6.79181 19.8181 7.74395 20.2908 8.83854C20.7636 9.93314 21 11.1027 21 12.3472C21 13.5918 20.7638 14.7619 20.2915 15.8575C19.8192 16.9531 19.1782 17.9061 18.3685 18.7166C17.5588 19.5271 16.6066 20.1687 15.512 20.6414C14.4174 21.1142 13.2479 21.3506 12.0034 21.3506ZM12 20.3506C14.2333 20.3506 16.125 19.5756 17.675 18.0256C19.225 16.4756 20 14.5839 20 12.3506C20 10.1173 19.225 8.22559 17.675 6.67559C16.125 5.12559 14.2333 4.35059 12 4.35059C9.76667 4.35059 7.875 5.12559 6.325 6.67559C4.775 8.22559 4 10.1173 4 12.3506C4 14.5839 4.775 16.4756 6.325 18.0256C7.875 19.5756 9.76667 20.3506 12 20.3506Z",
    fill: "#B8B9BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.8c467395c6912146f31782b757f81d86.svg";
export { ForwardRef as ReactComponent };